import Link from "next/link";
import type { SocialService } from "../db/schema/operational/enums";
import { getSocialProfileUrl } from "@drpcrd/utils/socials";
import { Typography } from "./typography";

type Props = {
  service: SocialService;
  handle: string;
};

const SERVICE_LABEL: Record<SocialService, string> = {
  tiktok: "TikTok",
  facebook: "Facebook",
  youtube: "YouTube",
  instagram: "Instagram",
  twitter: "Twitter",
  snapchat: "Snapchat",
  cameo: "Cameo",
  twitch: "Twitch",
};

const normalizeHandle = (handle: string): string =>
  handle.trim().replace(/^@+/, "");

export const CreatorSocialHandleLink = ({ service, handle }: Props) => {
  const cleanHandle = normalizeHandle(handle);

  if (!cleanHandle) {
    return null;
  }

  return (
    <Link
      href={getSocialProfileUrl(service, cleanHandle)}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-0.5 hover:underline"
    >
      <Typography as="span" size="sm" color="neutral">
        {SERVICE_LABEL[service]}
      </Typography>
      <Typography as="span" size="sm" color="action">
        @{cleanHandle}
      </Typography>
    </Link>
  );
};
